module.exports = __webpack_public_path__ + "img/CellCycle-GBM_10X_TPCP.27d3ecc7.png";